"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDivider_unstable", {
    enumerable: true,
    get: ()=>useDivider_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const useDivider_unstable = (props, ref)=>{
    const { alignContent ='center' , appearance ='default' , inset =false , vertical =false , wrapper  } = props;
    const dividerId = (0, _reactUtilities.useId)('divider-');
    return {
        // Props passed at the top-level
        alignContent,
        appearance,
        inset,
        vertical,
        // Slots definition
        components: {
            root: 'div',
            wrapper: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            role: 'separator',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            'aria-labelledby': props.children ? dividerId : undefined,
            ...props,
            ref
        }),
        wrapper: (0, _reactUtilities.resolveShorthand)(wrapper, {
            required: true,
            defaultProps: {
                id: dividerId,
                children: props.children
            }
        })
    };
}; //# sourceMappingURL=useDivider.js.map

//# sourceMappingURL=useDivider.js.map